import { render } from "./MonitorMsg.vue?vue&type=template&id=664fab83&scoped=true"
import script from "./MonitorMsg.vue?vue&type=script&lang=js"
export * from "./MonitorMsg.vue?vue&type=script&lang=js"

import "./MonitorMsg.vue?vue&type=style&index=0&id=664fab83&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664fab83"]])

export default __exports__